<mat-form-field class="w-100">
    <mat-label>Временная зона</mat-label>
    <mat-select
        [(ngModel)]="this.timeZoneService.currentTimeZone"
    >
        @for (timeZone of enumService.enumTimezoneToArrSelects(TimeZoneEnum); track timeZone.value) {
            <mat-option [value]="timeZone.value" [matTooltip]="timeZone.tooltip">
                {{timeZone.label}}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
